import { createApp } from 'vue'
import { createPinia } from 'pinia'
import * as VueI18n from 'vue-i18n'
import App from './App.vue'
import router from './router'
import 'bootstrap'
import enLocales from './locales/en'

const pinia = createPinia()

const i18n = VueI18n.createI18n({
  locale: 'en',
  fallbackLocale: 'en',
  warnHtmlInMessage: 'off',
  messages: {
    en: enLocales,
  },
})

const app = createApp(App).use(pinia).use(router).use(i18n)

const wrapper = document.querySelector('.vuejs-wrapper')

if (wrapper) {
  // Only for drupal app
  const appContainer = document.createElement('div')
  appContainer.setAttribute('id', 'vuejs-app')

  wrapper.insertBefore(appContainer, wrapper.childNodes[0])

  app.mount('#vuejs-app')
} else {
  // Only for dev
  app.mount('#app')
}
